export default function Guarantee() {
  return (
    <section id="garantia" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid lg:grid-cols-2 gap-0">
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6 w-fit">
                <i className="ri-shield-star-line text-xl text-white"></i>
                <span className="text-sm font-semibold text-white">Nossa Garantia</span>
              </div>

              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                <span className="bg-white text-teal-600 px-4 py-2 rounded-lg inline-block">Financiamento Aprovado Garantido</span>
              </h2>

              <p className="text-lg text-teal-50 mb-8 leading-relaxed">
                Se você possui <strong className="text-white">nome limpo</strong> e <strong className="text-white">renda comprovada</strong>, garantimos a aprovação do seu financiamento pelo programa Minha Casa Minha Vida.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-checkbox-circle-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1">Nome Limpo no CPF</h3>
                    <p className="text-sm text-teal-50">
                      Sem restrições nos órgãos de proteção ao crédito (SPC, Serasa)
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-file-list-3-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1">Renda Comprovada</h3>
                    <p className="text-sm text-teal-50">
                      Documentação que comprove renda mensal compatível com o financiamento
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-white mb-1">Processo Seguro</h3>
                    <p className="text-sm text-teal-50">
                      Acompanhamento completo desde a análise até a aprovação final
                    </p>
                  </div>
                </div>
              </div>

              <button
                onClick={() => {
                  const element = document.getElementById('formulario');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-white text-teal-600 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-50 transition-all transform hover:scale-105 w-full sm:w-auto cursor-pointer whitespace-nowrap"
              >
                Verificar Minha Elegibilidade
              </button>
            </div>

            <div className="relative h-64 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/006bc86d574cef377166f6d09ae20292.jpg"
                alt="Casal feliz com financiamento aprovado"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/20 to-transparent lg:hidden"></div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">100% Seguro</h3>
            <p className="text-sm text-gray-600">
              Processo regulamentado e aprovado pela Caixa Econômica Federal
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Suporte Dedicado</h3>
            <p className="text-sm text-gray-600">
              Equipe especializada para tirar todas as suas dúvidas
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-time-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Aprovação Rápida</h3>
            <p className="text-sm text-gray-600">
              Resposta em até 15 dias úteis após envio da documentação
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
